import React from 'react'
import AboutNl from "./about/nl";
import AboutFr from "./about/fr";
import AboutDe from "./about/de";
import {connect} from "react-redux";

class About extends React.Component {
  constructor(props) {
    super(props);
    this.language = props.intl.locale
  }

  render() {
    let language = this.language;
    if (language == "fr") {
      return <AboutFr/>
    } else if (language == "de") {
      return <AboutDe/>
    } else
     return <AboutNl/>
  }
}

function mapStateToProps(state) {
  const {intl} = state;
  return {
    intl
  };
}
export default connect(mapStateToProps)(About);



/** WEBPACK FOOTER **
 ** ./src/modules/helptexts/About.js
 **/